export class DisableSelect {
    private element: HTMLElement;

    constructor() {
        this.element = document.createElement('DIV');
        document.body.appendChild(this.element);

        this.element.innerHTML = DISABLE_SELECT_STYLE;

        //todo maybe unselect all the text
    }

    tick() {
        const selection = window.getSelection();
        if (selection) {
            selection.removeAllRanges();
        }
    }

    remove() {
        this.element.remove();
    }
}

const DISABLE_SELECT_STYLE = `
<style>
*{
    user-select: none!important;
}
</style>
`;
